<template>
  <el-dialog
    v-model="dialogVisible"
    width="60%"
    destroy-on-close
  >
    <Container
      :title="t('pay.cancelSlipPayment')"
    >
      <template #main>
        <h3>{{ t('pay.toBeCancelSlipPayment') }}</h3>
        <SimpleTable
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadOperate="false"
        />
        <h3>{{ t('pay.afterCancelSlipPayment') }}</h3>
        <SimpleTable
          :listLoading="listLoading"
          :tableData="tableDataSub"
          :columnStruct="columnStruct"
          :hadOperate="false"
        />
        <el-form
          ref="cFormRef"
          label-position="left"
          style="margin-left:35%; font-size: 14px;"
        >
          <el-row :gutter="5">
            <el-col :span="24">
              <el-form-item
                label-width="50%"
                style="text-align: right; margin-top: 15px;"
              >
                <el-button
                  ref="opsButton"
                  class="order-button"
                  @click="handleCancel"
                >
                  {{ t('pay.cancel') }}
                </el-button>
                <el-button
                  ref="opsButton"
                  class="order-button"
                  type="primary"
                  @click="handleConfirm"
                >
                  {{ t('pay.confirm') }}
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
  </el-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { formatDate, formatThousands } from '@/utils'
import Container from '@/components/form/container/Container.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { cancelSplitPaymentSlipWork } from '@/apis/paymentSlip/paymentSlip'
import { PaymentSlipWorkModel } from '@/model/paymentSlip/paymentSlipModel'

export default defineComponent({
  name: 'PaymentCancelSlipWorkDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    dataId: {
      type: Number,
      required: true
    },
    workData: {
      type: Object,
      default: null
    }
  },
  components: { SimpleTable, Container },
  emits: ['update:modelValue', 'refresh'],
  setup(props, context) {
    const { t } = useI18n()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const paymentSlipTableStruct = [
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'companyBankName', label: t('pay.PaymentBank') },
      { prop: 'payee', label: t('pay.payee') },
      { prop: 'bankName', label: t('pay.ReceivingBank') },
      { prop: 'amount', label: t('pay.PaymentAmount'), formatter: (row: any) => formatThousands(row.amount), align: 'right' },
      { prop: 'dueDate', label: t('Acceptance.dueDate'), formatter: (row: any) => formatDate(row.dueDate, 'yyyy-MM-dd') },
      { prop: 'paymentDate', label: t('pay.paymentDay'), formatter: (row: any) => formatDate(row.paymentDate, 'yyyy-MM-dd') }
    ]
    const dataMap = reactive({
      tableData: Array<PaymentSlipWorkModel>(),
      tableDataSub: Array<PaymentSlipWorkModel>(),
      listLoading: true,
      columnStruct: paymentSlipTableStruct,
      async getCompanyBankList() {
        dataMap.listLoading = true
        dataMap.tableData = [props.workData] as Array<PaymentSlipWorkModel>
        const work = Object.assign({} as PaymentSlipWorkModel, props.workData)
        work.children = []
        dataMap.tableDataSub = [work]

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const handleConfirm = async() => {
      const res = await cancelSplitPaymentSlipWork(props.dataId)
      if (res?.data && res?.data > 0) {
        ElMessage({
          message: t('common.setSuccess'),
          type: 'success',
          duration: 2000
        })
        context.emit('refresh')
        dialogVisible.value = false
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
          duration: 2000
        })
      }
    }
    onMounted(() => {
      dataMap.getCompanyBankList()
    })
    return {
      t,
      dialogVisible,
      handleCancel,
      handleConfirm,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">
.fixed-bottom-button {
  position: fixed;
  text-align: right;
  bottom: 40px; /* 距离底部的距离 */
  right: 20px; /* 距离右边的距离 */
}
</style>
